import * as tslib_1 from "tslib";
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getArtAuthor } from './redux/selectors';
import { fetchArtAuthor as fetchArtAuthorAction } from './redux/actions';
var mapStateToProps = function (state, ownProps) { return ({
    artAuthor: ownProps.artAuthor || getArtAuthor(state),
}); };
var mapDispatchToProps = {
    fetchArtAuthor: fetchArtAuthorAction,
};
function wrapComponent(Component) {
    // tslint:disable-next-line only-arrow-functions
    return function WrapperComponent(_a) {
        var artImageSrc = _a.artImageSrc, artAuthor = _a.artAuthor, artAuthorUsername = _a.artAuthorUsername, fetchArtAuthor = _a.fetchArtAuthor, props = tslib_1.__rest(_a, ["artImageSrc", "artAuthor", "artAuthorUsername", "fetchArtAuthor"]);
        // Load art author user data on the first render.
        // If we're not in production, use chris as the username to avoid
        // getting an error due to inexistent user data.
        useEffect(function () {
            !artAuthor &&
                fetchArtAuthor &&
                artAuthorUsername &&
                fetchArtAuthor({
                    username: process.env.NODE_ENV === 'development'
                        ? 'chris'
                        : artAuthorUsername,
                });
        });
        return (React.createElement(Component, tslib_1.__assign({ artImageSrc: artImageSrc, artAuthor: artAuthor }, props)));
    };
}
export default function withPopupArt(component) {
    return connect(mapStateToProps, mapDispatchToProps)(wrapComponent(component));
}
//# sourceMappingURL=withPopupArt.js.map